import React from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { runExcelOperationWithLoading } from '@/lib/excel/operation-loading';
import { useExcelSheets } from '@/hooks/use-excel-sheets';
import { ExcelImportDialogProps } from './types';
import ExcelOptionsTab from './ExcelOptionsTab';
import ExcelSheetTab from './ExcelSheetTab';
import ExcelFileTab from './ExcelFileTab';

const ExcelImportDialog = ({
  open,
  onClose,
  onSubmit,
  title = 'Lấy dữ liệu từ excel',
  titleIcon = <AritoIcon icon={555} />,
  initialData,
  showOptionsTab = true,
  errorOptions,
  className = 'w-[800px]',
  maxWidth = 'lg'
}: ExcelImportDialogProps) => {
  const [, setIsSubmitting] = React.useState(false);
  const {
    sheetOptions,
    isLoading,
    readSheetsFromFile,
    refreshSheets,
    clearSheets,
    selectedFile,
    selectedSheetIndex,
    setSelectedSheetIndex
  } = useExcelSheets();

  const defaultInitialData = React.useMemo(() => {
    return {
      sheetIndex: selectedSheetIndex,
      errors: '100',
      ...initialData
    };
  }, [selectedSheetIndex, initialData]);

  const handleSubmit = async (data: any) => {
    handleClose();
    await runExcelOperationWithLoading({
      setLoading: setIsSubmitting,
      message: 'Đang nhập dữ liệu từ Excel...',
      operation: async () => {
        await onSubmit({ ...data, file: selectedFile, sheetIndex: selectedSheetIndex });
      }
    });
  };

  const handleClose = () => {
    clearSheets();
    onClose();
  };

  const tabs = [
    {
      id: 'option',
      label: 'Tùy chọn',
      component: (
        <ExcelSheetTab
          sheetOptions={sheetOptions}
          isLoading={isLoading}
          onSheetChange={setSelectedSheetIndex}
          onRefresh={refreshSheets}
        />
      )
    }
  ];

  if (showOptionsTab) {
    tabs.push({
      id: 'other',
      label: 'Khác',
      component: <ExcelOptionsTab errorOptions={errorOptions} />
    });
  }

  return (
    <DialogV2
      open={open}
      onClose={handleClose}
      title={title}
      maxWidth={maxWidth}
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={titleIcon}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        onSubmit={handleSubmit}
        className={className}
        initialData={defaultInitialData}
        headerFields={
          <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
            <ExcelFileTab onFileChange={readSheetsFromFile} />

            <HeaderTabsV2 tabs={tabs} className='border-b border-b-gray-200' />
          </div>
        }
        bottomBar={<BottomActionBarV2 onClose={handleClose} mode='add' />}
      />
    </DialogV2>
  );
};

export { ExcelImportDialog };
export type { ExcelImportDialogProps, ExcelImportData, SheetOption } from './types';
export { default as ExcelFileTab } from './ExcelFileTab';
export { default as ExcelSheetTab } from './ExcelSheetTab';
export { default as ExcelOptionsTab } from './ExcelOptionsTab';
export { ExcelImportErrorDialog } from './ExcelImportErrorDialog';
export type { ExcelImportErrorDialogProps } from './ExcelImportErrorDialog';
